
    import {groupInstrumentByType, groupInstrumentByCity,groupInstrumentCountByType, groupInstrumentCountByCity} from "../../js/instrumentType/instrumentType";
    import {Component, Vue, Watch} from "vue-property-decorator";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import echarts from "echarts";
    import {instrumentAll} from "@/js/referenceMaterial/referenceMaterial";
    @Component({
        name: "Approval_Index",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        title = '';
        mode = '0' //0 按器具分类统计  1 生产企业地区分布情况统计
        resultList = [] as any;
        tableList = [] as any;
        pageIndex = 0;
        pageSize = 10;
        totalCount = 0;
        modal = {
            visible: false,
        }
        listTotal = 0;
        showForm = false;
        instrumentTypes = [
          {name: '新建科研项目', id: 1},
          {name: '储备科研项目', id: 2},
          {name: '在研科研项目', id: 3},
          {name: '结题科研项目', id: 4}
        ];
        propParams = {
            city_name: "",
            instr_type: "",
            instr_name: "",
            org_name: "",
        }
        myChart = null as any;
        fullScreen = false;

      // 增删改
      editId = '';
      editDialog = false;
      addform = {
        name: "",  //科研项目名称
        status: "",    //科研项目进度
        orgName: "",    //单位名称
        startDate: "",    //研发开始日期
        endDate: "",    //计划结束日期
      } as any

        mounted() {
          this.jumpPage(1);
        }

        indexMethod(index: any) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        }
        doLayout(el: any){
           const e = this.$refs[el] as any;
            if(e){
                e.doLayout() // 解决表格错位
            }
        }
        pageSizeChange(val: number) {
            this.pageSize = val;
            this.jumpPage(this.pageIndex);
        }
        refresh(){
            this.jumpPage(1);
        }
        reset(){
            this.propParams.instr_type = '';
            this.propParams.instr_name = '';
            this.propParams.city_name = '';
            this.propParams.org_name = '';
            this.refresh();
        }
        jumpPage(val: any){
            let resultList = JSON.parse(JSON.stringify(this.resultList));
            const {instr_name, instr_type, city_name, org_name} = this.propParams;
            if(instr_name != ''){
                resultList = resultList.filter((r: any) => r.instr_name.indexOf(instr_name) > -1);
            }
            if(instr_type != ''){
                resultList = resultList.filter((r: any) => r.instr_type == instr_type);
            }
            if(city_name != ''){
                resultList = resultList.filter((r: any) => r.city_name.indexOf(city_name) > -1);
            }
            if(org_name != ''){
                resultList = resultList.filter((r: any) => r.org_name.indexOf(org_name) > -1);
            }
            const tableList = resultList;
            this.totalCount = resultList.length;
            this.pageIndex = val;
            const pageIndex = val;
            const pageSize = this.pageSize;
            const totalCount = tableList.length;
            const start = (pageIndex - 1) * pageSize;
            const end = pageIndex * pageSize > totalCount ? totalCount : pageIndex * pageSize;
          // this.tableList = tableList.slice(start, end);
          this.tableList = [
            {name: '2023科研任务', status: '新建科研项目', orgName: '中科院', startDate: '2023-01-01', endDate: '2025-12-31'}
          ]
          this.totalCount = 1;
        }
        loadGroupInstrumentCountByCity(){
            let resultList = [] as any;
            for(let m in groupInstrumentByCity){
                resultList =  resultList.concat(groupInstrumentByCity[m]);
            }
            this.resultList = resultList;
            const tableData = groupInstrumentCountByCity;
            const xAxisData = tableData.map((t: any) => t.name);
            const seriesData = tableData.map((t: any) => t.value);
            this.jumpPage(1);
            this.loadEchart(xAxisData, seriesData);
        }
        loadGroupInstrumentCountByType(){
            let resultList = [] as any;
            for(let m in groupInstrumentByType){
                resultList =  resultList.concat(groupInstrumentByType[m]);
            }
            this.resultList = resultList;
            const tableData = groupInstrumentCountByType;
            const xAxisData = tableData.map((t: any) => t.name);
            const seriesData = tableData.map((t: any) => t.value);
            this.jumpPage(1);
            this.loadEchart(xAxisData, seriesData);
        }
        loadEchart(xAxisData: any, seriesData: any){
            if(this.myChart){
                this.myChart.dispose();
            }
            this.myChart = echarts.init(this.$refs.chart1);
            this.myChart.setOption({
                title: {
                    text: this.title
                },
                tooltip: {},
                xAxis: {
                    data: xAxisData
                },
                yAxis: {},
                dataZoom: [
                    {
                        show: true,
                        realtime: true,
                        start: 0,
                        end: 50
                    },
                    {
                        type: 'inside',
                        realtime: true,
                        start: 0,
                        end: 50
                    }
                ],
                series: [
                    {
                        name: this.mode == '0' ? '分类' : '地区',
                        type: 'bar',
                        data: seriesData,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                                    offset: 0,
                                    color: "#1268f3" // 0% 处的颜色
                                }, {
                                    offset: 0.6,
                                    color: "#08a4fa" // 60% 处的颜色
                                }, {
                                    offset: 1,
                                    color: "#01ccfe" // 100% 处的颜色
                                }], false)
                            },
                        },
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                color: 'red',
                                fontSize: 16
                            }
                        }
                    }
                ]
            });
        }

      // 增删改
      add() {
        this.addform = {
          name: "",  //项目名称
          status: "",    //项目类型
          times: "",    //时间
          user: "",    //负责人
        }
        this.editDialog = true;
        this.editId = '';
      }
      saveBtn() {
        if (this.editId) {
          this.$set(this.tableList,this.editId,this.addform);
        } else {
          const form = Object.assign({}, this.addform, {id: this.tableList.length});
          this.tableList.push(form);
        }
        this.editDialog = false;
        this.totalCount = this.tableList.length;
      }
      del(index: number) {
        this.$confirm('确定要删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableList.splice(index, 1);
          this.totalCount = this.tableList.length;
        })
      }
      edit(index: number) {
        this.editId = String(index);
        this.addform = JSON.parse(JSON.stringify(this.tableList[index]));
        this.editDialog = true;
      }
    }
